import './reviews.css';
import { useEffect, useState } from 'react';
import perImage from '../../../../assets/icons/trvto_tourGuideSelected.png';
import ReviewStars from '../../../../components/reviewStars/ReviewStars';
import { getReviewsData } from '../../../api/infoOrgApi';
// import { getReviewDate } from "../../../utils/date";

export default function Reviews({ data, type }) {
    const [reviews, setReviews] = useState([]);
    useEffect(() => {
        const getReviews = async () => {
            const res = await getReviewsData(type, data._id);
            setReviews(res.data);
        };
        getReviews();
    }, [data._id, type]);

    return (
        <div>
            {reviews?.map((review, reviewIndex) => {
                return (
                    <div key={reviewIndex} className='reviewDiv'>
                        <div className='reviewImgText'>
                            <img src={perImage} alt={review?.userName + 'image'} className='reviewImg' />
                            <div className='reviewStarsName'>
                                <span className='reviewUserName'>{review?.userName}</span>
                                <div className='reviewNameTime'>
                                    <ReviewStars rating={review?.rating} />
                                    <span className='reviewDate'>{review?.packId?.title}</span>
                                    {/* <span className="reviewDate">{getReviewDate(review.createdAt)}</span> */}
                                </div>
                                <span className='reviewComment'>{review?.comment}</span>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
